import { render } from "./ThankYouMessageWithInvoice.vue?vue&type=template&id=f3d0ca64"
import script from "./ThankYouMessageWithInvoice.vue?vue&type=script&lang=js"
export * from "./ThankYouMessageWithInvoice.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\bdroyelfrontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__